import { LuckyCard, LuckyCardStatus } from "../types/LuckyCard";
import cardPattern from "@/assets/img/img_card_pattern.webp";

interface LuckyCardItemProps {
  card: LuckyCard | null;
  onClick?: () => void;
  withoutStatus?: boolean;
  height?: string;
}

const LuckyCardItem = ({card, onClick, withoutStatus, height }: LuckyCardItemProps) => {

const borderColor = card?.luckyCardStatus === LuckyCardStatus.Lucky
  ? "2px solid #FFD700"
  : card?.luckyCardStatus === LuckyCardStatus.Selected
  ? "2px solid #007BFF"
  : card?.luckyCardStatus === LuckyCardStatus.Guessed
  ? "2px solid #28A745"
  : "2px solid transparent";


  return (
    <div className={`${height ? height :""} w-full h-full p-[4px]`}
    style={{
      width: "100%",
      height: "100%",
      position: "relative",
      boxShadow: "0 2px 8px rgba(0,0,0,0.12)",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      overflow: "hidden",
    }}
    
    >
      {card?.luckyCardStatus === null && !withoutStatus && 
      
      <div className="flex justify-center items-center absolute top-0 left-0  w-full h-full z-10">
      <div 
      className=" bg-black rounded-lg  opacity-40"
      style={{
        height: "100%",
        borderRadius: "6px",
        objectFit: "cover", 
        display: "block",
        aspectRatio: "11/19",
        zIndex: 1000,
      }}
      />
      </div>
      }
      <img
        src={card?.card ? card.card.image : cardPattern}
        alt={card?.card ? card.card.name : "lucky-card-item"}

        style={{
          height: "100%",
          borderRadius: "6px",
          border: withoutStatus ? "2px solid white" : borderColor,
          objectFit: "cover", 
          display: "block",
          aspectRatio: "11/19",
        }}
        className={`
        ${
          card?.luckyCardStatus === null && "hover:scale-105"
        }`}
        onClick={onClick ? onClick : undefined}
      />
    </div>
  );
};

export default LuckyCardItem;
